import ESIGNATURE_BG from './images/esignature-bg.png';

export default { ESIGNATURE_BG };
